import {
  ARTICLE_LOADING,
  ARTICLE_END_LOADING,
  ARTICLE_LOADING_OPERATION,
  ARTICLE_END_LOADING_OPERATION,
  ARTICLE_GET_DATA,
  ARTICLE_GET_ITEM,
  ARTICLE_CLEAR,
  ARTICLE_UPDATE_STATUS,
  ARTICLE_DELETE_ELEMENT,
  ARTICLE_UPDATE_SINGLE,
  ARTICLE_ADD_SINGLE,
} from "../redux/types";

import * as api from "./api";

/**
 * Obtiene todos los articulos del cliente actual
 */
export const getClientArticles =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: "/articles/getcurrents",
      loadingType: ARTICLE_LOADING,
      successType: ARTICLE_GET_DATA,
      errorType: ARTICLE_END_LOADING,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

/**
 * Obtiene todos los articulos del cliente actual
 */
export const getClientArticleById =
  (id: string | number, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: `/articles/getfor_client/${id}`,
      loadingType: ARTICLE_LOADING_OPERATION,
      successType: ARTICLE_GET_ITEM,
      errorType: ARTICLE_END_LOADING_OPERATION,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

/**
 * Obtiene todos los articulos del cliente actual que no tengan paquete asignado
 */
export const getClientArticlesAvailables =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: "/articles/getavailables",
      loadingType: ARTICLE_LOADING,
      successType: ARTICLE_GET_DATA,
      errorType: ARTICLE_END_LOADING,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

/**
 * Crea un nuevo articulo
 */
export const createClientArticle =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/articles/create_forclient",
      loadingType: ARTICLE_END_LOADING_OPERATION,
      successType: ARTICLE_GET_ITEM,
      errorType: ARTICLE_END_LOADING_OPERATION,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

/**
 * Crea un nuevo articulo
 */
export const updateClientArticle =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: `/articles/update_forclient/${data?.id || 0}`,
      loadingType: ARTICLE_END_LOADING_OPERATION,
      successType: ARTICLE_GET_ITEM,
      errorType: ARTICLE_END_LOADING_OPERATION,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const updateArticleStatus =
  (data, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/articles/update_status",
      loadingType: ARTICLE_LOADING_OPERATION,
      successType: ARTICLE_UPDATE_STATUS,
      errorType: ARTICLE_END_LOADING_OPERATION,
      data,
      successPayload: data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const deleteClientArticle =
  (id: string | number, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.deletefn(dispatch, {
      url: `/articles/delete_forclient/${id}`,
      loadingType: ARTICLE_LOADING_OPERATION,
      successType: ARTICLE_DELETE_ELEMENT,
      errorType: ARTICLE_END_LOADING_OPERATION,
      successPayload: {
        id,
      },
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

// Admin
/**
 * Obtiene todos los articulos
 */
export const getAllArticles =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/articles/get_abs_all",
      loadingType: ARTICLE_LOADING,
      successType: ARTICLE_GET_DATA,
      errorType: ARTICLE_END_LOADING,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const createArticle =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/articles/create",
      loadingType: ARTICLE_LOADING_OPERATION,
      successType: ARTICLE_ADD_SINGLE,
      errorType: ARTICLE_END_LOADING_OPERATION,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const markArticleReceived =
  (id_article, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: `/articles/mark_received/${id_article}`,
      loadingType: ARTICLE_LOADING_OPERATION,
      successType: ARTICLE_UPDATE_SINGLE,
      errorType: ARTICLE_END_LOADING_OPERATION,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const updateArticle =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/articles/update",
      loadingType: ARTICLE_LOADING_OPERATION,
      successType: ARTICLE_UPDATE_SINGLE,
      errorType: ARTICLE_END_LOADING_OPERATION,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const deleteArticle =
  (id, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.deletefn(dispatch, {
      url: `/articles/delete/${id}`,
      loadingType: ARTICLE_LOADING_OPERATION,
      successType: ARTICLE_DELETE_ELEMENT,
      errorType: ARTICLE_END_LOADING_OPERATION,
      successPayload: {
        id,
      },
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const setEditArticleFromFunction = (article) => (dispatch) => {
  dispatch({
    type: ARTICLE_GET_ITEM,
    payload: article,
  });
};

export const clearArticle = () => (dispatch) => {
  dispatch({
    type: ARTICLE_CLEAR,
  });
};
